import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.form = this.element.closest("form");
    if (!this.form) {
      console.warn("Couldn't find form to interact with");
      return;
    }

    this.check();
    this.boundClick = (e) => {
      this.defaultInputs().forEach((input) => {
        if (input.getAttribute("data-default")) {
          input.click();
        }
      });
      this.form.submit();
    };
    this.element.addEventListener("click", this.boundClick);

    this.boundChange = () => this.check();
    this.form.addEventListener("change", this.boundChange);
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundClick);
    if (this.form) {
      this.form.removeEventListener("change", this.boundChange);
    }
  }

  defaultInputs() {
    return Array.prototype.slice
      .call(this.form.getElementsByTagName("input"))
      .filter((input) => input.getAttribute("data-default"));
  }

  check() {
    const uncheckedInput = this.defaultInputs().find((input) => !input.checked);
    if (uncheckedInput) {
      this.element.classList.remove("disabled");
      this.element.removeAttribute("disabled");
    } else {
      this.element.classList.add("disabled");
      this.element.setAttribute("disabled", true);
    }
  }
}
